module.exports = __webpack_public_path__ + "static/media/vrbusthumb.653749d3.jpg";